module.exports = __webpack_public_path__ + "static/media/card-blog3.47bb87fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/card-blog3.jpg
// module id = 234
// module chunks = 0